module.exports = __webpack_public_path__ + "static/media/Hebrew_Private.9d539cab.svg";